/**
 * Crea los carteles de Mano
 * @param {*} scene
 */
export function crearCartelesMano(scene) {
  /*/=======================================================================================\*\
  ||                                CARTELES JUGADOR 1 MANO 1                                ||
  \*\=======================================================================================/*/
  scene.cartelJugador1Mano1BlackJack = scene.add.image(
    502,
    230,
    'cartelManoBlackJack'
  );
  scene.cartelJugador1Mano1BlackJack.setDepth(500);
  scene.cartelJugador1Mano1BlackJack.setVisible(false);

  scene.cartelJugador1Mano1Gana = scene.add.image(502, 230, 'cartelManoGana');
  scene.cartelJugador1Mano1Gana.setDepth(500);
  scene.cartelJugador1Mano1Gana.setVisible(false);

  scene.cartelJugador1Mano1Empate = scene.add.image(
    502,
    230,
    'cartelManoEmpate'
  );
  scene.cartelJugador1Mano1Empate.setDepth(500);
  scene.cartelJugador1Mano1Empate.setVisible(false);

  scene.cartelJugador1Mano1Pierde = scene.add.image(
    502,
    230,
    'cartelManoPierde'
  );
  scene.cartelJugador1Mano1Pierde.setDepth(500);
  scene.cartelJugador1Mano1Pierde.setVisible(false);

  scene.cartelJugador1Mano1Excede21 = scene.add.image(
    502,
    230,
    'cartelManoExcede21'
  );
  scene.cartelJugador1Mano1Excede21.setDepth(500);
  scene.cartelJugador1Mano1Excede21.setVisible(false);

  /*/=======================================================================================\*\
  ||                                CARTELES JUGADOR 1 MANO 2                                ||
  \*\=======================================================================================/*/
  scene.cartelJugador1Mano2BlackJack = scene.add.image(
    662,
    158,
    'cartelManoBlackJack'
  );
  scene.cartelJugador1Mano2BlackJack.setDepth(500);
  scene.cartelJugador1Mano2BlackJack.setVisible(false);

  scene.cartelJugador1Mano2Gana = scene.add.image(662, 158, 'cartelManoGana');
  scene.cartelJugador1Mano2Gana.setDepth(500);
  scene.cartelJugador1Mano2Gana.setVisible(false);

  scene.cartelJugador1Mano2Empate = scene.add.image(
    662,
    158,
    'cartelManoEmpate'
  );
  scene.cartelJugador1Mano2Empate.setDepth(500);
  scene.cartelJugador1Mano2Empate.setVisible(false);

  scene.cartelJugador1Mano2Pierde = scene.add.image(
    662,
    158,
    'cartelManoPierde'
  );
  scene.cartelJugador1Mano2Pierde.setDepth(500);
  scene.cartelJugador1Mano2Pierde.setVisible(false);

  scene.cartelJugador1Mano2Excede21 = scene.add.image(
    662,
    158,
    'cartelManoExcede21'
  );
  scene.cartelJugador1Mano2Excede21.setDepth(500);
  scene.cartelJugador1Mano2Excede21.setVisible(false);

  /*/=======================================================================================\*\
  ||                                        CARTELES DEALER                                  ||
  \*\=======================================================================================/*/
  scene.cartelDealerManoBlackJack = scene.add.image(
    502,
    58,
    'cartelManoBlackJack'
  );
  scene.cartelDealerManoBlackJack.setDepth(500);
  scene.cartelDealerManoBlackJack.setVisible(false);

  scene.cartelDealerManoGana = scene.add.image(502, 58, 'cartelManoGana');
  scene.cartelDealerManoGana.setDepth(500);
  scene.cartelDealerManoGana.setVisible(false);

  scene.cartelDealerManoEmpate = scene.add.image(502, 58, 'cartelManoEmpate');
  scene.cartelDealerManoEmpate.setDepth(500);
  scene.cartelDealerManoEmpate.setVisible(false);

  scene.cartelDealerManoPierde = scene.add.image(502, 58, 'cartelManoPierde');
  scene.cartelDealerManoPierde.setDepth(500);
  scene.cartelDealerManoPierde.setVisible(false);

  scene.cartelDealerManoExcede21 = scene.add.image(
    502,
    58,
    'cartelManoExcede21'
  );
  scene.cartelDealerManoExcede21.setDepth(500);
  scene.cartelDealerManoExcede21.setVisible(false);
}
